import { combineReducers } from "redux";
import { deletedProjects, projectsCount, purchasedProjects, savedProjects, saveTabName, lastAction } from "./project_actions_reducer";
import { makeProjectsActionType, projectsCountState, resource } from "../action";
import ActionTypes from "../../constants";

// @ts-ignore
const logger = photoOrg.clientLogger;

interface lastActionInterface {
    type: string;
    payload: Object;
}

export interface state {
    saved: resource[];
    deleted: resource[];
    purchased: resource[];
    projectsCount: projectsCountState;
    currrentTabName: makeProjectsActionType;
    lastAction: lastActionInterface;
}

const appReducer = combineReducers<state>({
    saved: savedProjects,
    deleted: deletedProjects,
    purchased: purchasedProjects,
    projectsCount: projectsCount,
    currrentTabName: saveTabName,
    lastAction
})


export const rootReducer = (state:state, action) => {
    try{
        // Clear all data of specific key in redux store to initial.
        if(action.type === ActionTypes.RESET_STORE_DATA){
            state[action.payload] = undefined;
        } 
    } catch(error){
        logger.error({description: "LIBRARY:Reducers:rootReducer:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }
    return appReducer(state, action);
 };

 export default rootReducer;

 export type ROOT_STATE = ReturnType<typeof rootReducer>;